/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Menu,
    MenuFromJSON,
    MenuFromJSONTyped,
    MenuToJSON,
} from './';

/**
 * 
 * @export
 * @interface MenuDataFrame
 */
export interface MenuDataFrame {
    /**
     * 
     * @type {number}
     * @memberof MenuDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof MenuDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof MenuDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Menu>}
     * @memberof MenuDataFrame
     */
    data: Array<Menu>;
}

export function MenuDataFrameFromJSON(json: any): MenuDataFrame {
    return MenuDataFrameFromJSONTyped(json, false);
}

export function MenuDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(MenuFromJSON)),
    };
}

export function MenuDataFrameToJSON(value?: MenuDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(MenuToJSON)),
    };
}


